import React from 'react';

import PropTypes from 'prop-types';

import { AddressInput } from './address-input';
import { AutoCompleteField } from '../../../constants/autocomplete-field';
import { FIELD_NAMES } from '../constants';

export const EmailField = ({ optional = false }) => {
  return <AddressInput autoComplete={AutoCompleteField.Email} field={FIELD_NAMES.EMAIL} optional={optional} />;
};

EmailField.propTypes = {
  optional: PropTypes.bool,
};
